export const AMPLIFY_THEME = {
    toast: {
        position: "fixed",
        bottom: "0",
        top: "auto"
    },
    formContainer: {
        marginTop: "50px"
    }
};